/** Aplica máscara monetária pt-BR: "1234" → "12,34" */
export const maskCurrency = (value: string): string => {
  const numbers = value.replace(/\D/g, "");
  if (!numbers) return "";
  return (Number(numbers) / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/** Converte valor mascarado pt-BR de volta para número: "1.234,56" → 1234.56 */
export const parseCurrency = (masked: string): number => {
  const normalized = masked.replace(/\./g, "").replace(",", ".");
  const num = parseFloat(normalized);
  return isNaN(num) ? 0 : num;
};

/** Aplica máscara percentual: limita a 100 com 2 casas */
export const maskPercent = (value: string): string => {
  const numbers = value.replace(/\D/g, "");
  if (!numbers) return "";
  const num = Math.min(Number(numbers) / 100, 100);
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
